import * as Sentry from "@sentry/react";
import { omit, path } from "ramda";

import { createLocalAxios } from "../../lib/api.js";
import apiMessages from "../../lib/apiMessages.js";

import {
  loadingUrlEntries,
  loadingUrlEntriesDone,
  setUrlEntries,
} from "./slice.js";

export const fetchUrlEntries = (params) => async (dispatch, getState) => {
  const { page, pageSize } = params || {};

  dispatch(loadingUrlEntries());

  const localAxios = createLocalAxios(getState);
  const url = `url-entry/url-entries?page=${page}&page_size=${pageSize}`;

  let response;
  try {
    response = await localAxios.get(url);
  } catch (error) {
    console.error("Error while fetching the establishments:", error);
    throw error;
  } finally {
    await dispatch(loadingUrlEntriesDone());
  }

  await dispatch(setUrlEntries(response.data.urlEntries));

  return response.data.pages;
};

export const saveUrlEntry =
  (values, urlEntryId) => async (dispatch, getState) => {
    const localAxios = createLocalAxios(getState);
    const body = {
      ...omit(["audiences", "createdAt", "id", "updatedAt"], values),
      audiences: (values.audiences || []).map((audience) => ({
        id: path(["value", "id"], audience),
        resourceType: path(["value", "resourceType"], audience),
      })),
    };
    const url = urlEntryId
      ? `url-entry/url-entry/${urlEntryId}`
      : "url-entry/url-entry";

    let response;
    try {
      if (urlEntryId) {
        response = await localAxios.patch(url, body);
      } else {
        response = await localAxios.post(url, body);
      }
    } catch (error) {
      console.error("Error while saving the url entry", error);
      Sentry.captureException(
        new Error(`Something went wrong: saveUrlEntry post/patch-> ${error}`),
      );
      throw error;
    }

    if (response.data.message !== apiMessages.MSG_SUCCESS) {
      throw new Error(response.data.message);
    }

    return response;
  };

export const removeUrlEntry = (id) => async (dispatch, getState) => {
  const localAxios = createLocalAxios(getState);
  const url = `url-entry/url-entry/${id}`;

  try {
    await localAxios.delete(url);
  } catch (error) {
    console.error(`Error deleting url entry: ${error}`);
    Sentry.captureException(
      new Error(`Something went wrong: removeUrlEntry -> ${error}`),
    );
  }
};

export const fetchUrlEntryById = (id) => async (dispatch, getState) => {
  const localAxios = createLocalAxios(getState);
  const url = `url-entry/url-entry/${id}`;

  let response;
  try {
    response = await localAxios.get(url);
  } catch (error) {
    console.error("Error while fetching the url entry by ID:", error);
    new Error(`Something went wrong: fetchSoftwarePackageById -> ${error}`);
  }

  dispatch(setUrlEntries([response.data.data]));
  return response.data;
};

export const fetchAccountSuggestions =
  (query) => async (dispatch, getState) => {
    const localAxios = createLocalAxios(getState);
    const url = `account/suggest/${query}`;

    let response;
    try {
      response = await localAxios.get(url);
    } catch (error) {
      console.error("Error while fetching the account suggestions:", error);
      throw error;
    }
    return response.data;
  };
